import { useRef } from "react";
import Reveal from "./Reveal";
import { PEOPLE } from "../data/people";

function SpotlightAvatar({ person }) {
  const ref = useRef(null);

  const onMove = (event) => {
    const rect = ref.current.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    ref.current.style.setProperty("--mx", `${x}%`);
    ref.current.style.setProperty("--my", `${y}%`);
  };

  return (
    <div
      className="avatar"
      ref={ref}
      onPointerMove={onMove}
      data-testid={`portrait-${person.name.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {person.photo ? (
        <img
          src={person.photo}
          alt={`Portrait of ${person.name}`}
          width="72"
          height="72"
          loading="lazy"
          style={{ objectPosition: person.photoPosition || "50% 50%" }}
        />
      ) : (
        <span className="avatar-initials">{person.initials}</span>
      )}
      <span className="avatar-spotlight" aria-hidden="true"></span>
      <span className="avatar-ambient" aria-hidden="true"></span>
    </div>
  );
}

export default function People() {
  return (
    <section className="band band-canvas" id="people" data-testid="section-people">
      <div className="container">
        <Reveal>
          <div className="section-head">
            <p className="eyebrow">The people</p>
            <div>
              <h2>Who you will actually work with.</h2>
              <p className="lede">
                The two co-founders lead every family office engagement, with
                a partner brought in where a jurisdiction calls for one.
                Nobody else at the firm leads this work.
              </p>
            </div>
          </div>
        </Reveal>
        <div className="people-cards" data-testid="people-cards">
          {PEOPLE.map((person, index) => (
            <Reveal
              key={person.name}
              delay={index * 0.08}
              data-testid={`person-card-${person.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <article className="person-card">
                <SpotlightAvatar person={person} />
                <h3>{person.name}</h3>
                <p className="person-role">{person.role}</p>
                <p className="person-bio">{person.bio}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
